import queryString from 'query-string';
import { post, get } from './api';
import { QuotePayload } from '../store/OrderStore/getQuotePayload';
import {
  BrandingResponse,
  ErrorResponse,
  LabelResponse,
  OrderResponse,
  QuotesResponse,
  ReturnAccountSettingsResponse,
  SubmitReturnResponse,
} from './types';
import { ReturnPayload } from '../store/OrderStore/getReturnPayload';
import { setAuthToken } from '../store/authToken';

class Fetch {
  private token: string | null = null;

  setToken(token: string) {
    this.token = token;
    setAuthToken(token);
  }

  async fetchOrder(
    merchantReference: string,
    email: string,
    orderReference: string
  ) {
    return post<OrderResponse, ErrorResponse>('/returns/requests', {
      merchant_identifier: merchantReference,
      customer_email: email,
      purchase_reference: orderReference,
    });
  }

  async submitReturn(payload: ReturnPayload) {
    return post<SubmitReturnResponse, ErrorResponse>(
      '/returns/orders',
      payload,
      this.token
    );
  }

  async getLabel(
    payload: {
      purchase_reference: string;
      customer_email: string;
      request_id: number;
      merchant_id: number;
    },
    trackingNumber: string
  ) {
    return get<LabelResponse, ErrorResponse, {}>(
      `/returns/orders/${trackingNumber}/?${queryString.stringify(payload)}`,
      {},
      this.token
    );
  }

  async getBranding(merchant: string) {
    return get<BrandingResponse, ErrorResponse, {}>(
      `/returns_brandings?returns_store_identifier=${merchant}`
    );
  }

  async getQuotes(payload: QuotePayload) {
    return post<QuotesResponse, ErrorResponse>(
      `/quotes`,
      { ...payload, auth_token: this.token },
      this.token
    );
  }

  async getReturnAccountSettings(merchant: string) {
    return get<ReturnAccountSettingsResponse, ErrorResponse, {}>(
      `/returns_customer_support_details?returns_store_identifier=${merchant}`
    );
  }
}

export default Fetch;
